import { Injectable } from '@angular/core';
import { ApiService } from './helpers/api.service';
import { Observable } from 'rxjs';
import { apiResourcesV1 } from './helpers/api-resources';
import { map } from 'rxjs/operators';
import { Company } from '../interfaces/company.interface';

@Injectable()
export class CompanyService {
  constructor(private http: ApiService) {}

  getCompanies(params = null): Observable<any> {
    return this.http.get(apiResourcesV1.companies, params)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getCompany(id, params = {}): Observable<Company> {
    return this.http.get(`${apiResourcesV1.companies}/${id}`, params)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  createCompany(data): Observable<any> {
    return this.http.post(apiResourcesV1.companies, data)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  updateCompany(id, data): Observable<any> {
    return this.http.patch(`${apiResourcesV1.companies}/${id}`, data)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  getAvatars(id): Observable<any> {
    return this.http.get(`${apiResourcesV1.companies}/${id}/avatars`)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  uploadAvatar(id, data): Observable<any> {
    return this.http.post(`${apiResourcesV1.companies}/${id}/avatars`, data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  deleteAvatars(companyId, id): Observable<any> {
    return this.http.delete(`${apiResourcesV1.companies}/${companyId}/avatars/${id}`)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  deleteCompany(id): Observable<any> {
    return this.http.delete(apiResourcesV1.companies, id)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getReport(id, params): Observable<any> {
    return this.http.get(`${apiResourcesV1.companies}/${id}/usage_summary`, params)
      .pipe(map((res: any) => {
        return res;
      }));
  }

}
